import { css } from 'styled-components';

const focusOutline = /*#__PURE__*/css(["outline:", ";outline-offset:", ";"], ({
  theme
}) => theme.border.focus.default, ({
  theme
}) => theme.border.focusOffset);

export { focusOutline as f };
//# sourceMappingURL=focusOutline-oDdaDZ4N.js.map
